<script>
function redirectToMuven() {
    window.location = 'https://muven.com.br'
}

function redirectToNeiblo() {
    window.location = 'https://neiblo.com'
}
</script>

<section id="products">
    <h1>Produtos</h1>

    <div class="products-container">
        <div class="product">
            <img src="./assets/logo_muven.png" alt="Muven"  on:click={redirectToMuven}/>
            <p class="product-title">Integre seu ERP com os melhores e maiores ecommerces e marketplaces.</p>
            <p class="product-description">Já imaginou multiplicar suas vendas online e integrar diversas plataformas de venda em um único lugar?</p>
            <p class="product-description">O fluxo é bem simples: você cadastra os produtos, categorias e marcas em seu ERP e o <span class="call-to-action">muven</span> faz o envio para a sua loja virtual. Assim que seus clientes comprarem seus produtos, nós notificamos o seu ERP para que o estoque seja atualizado e você possa dar andamento no pedido como bem entender. Bem simples, né?</p>
            <p class="product-description">O <span class="call-to-action">muven</span> permite que você controle estatísticas, estoque, utilize preços diferenciados para diferentes plataformas, rastreie cada etapa da integração, visualize as regiões que mais compram em sua loja e muito mais!</p>
            <p class="product-description">Saiba mais <a href="https://muven.com.br" target="_blank">clicando aqui</a>.</p>
        </div>
        <div class="product">
            <img src="./assets/logo_neiblo.png" alt="Neiblo" on:click={redirectToNeiblo}/>
            <p class="product-title">Receba suas encomendas de forma fácil e prática.</p>
            <p class="product-description">O Neiblo oferece os melhores e mais confiáveis endereços para que você possa deixar sua encomenda enquanto não puder pegá-la.</p>
            <p class="product-description">Além disso, rastreamos sua encomenda, lhe enviamos notificações sobre tudo o que acontece e tomamos conta de muitas outras coisas para facilitar a sua vida.</p>
            <p class="product-description">Saiba mais <a href="https://neiblo.com" target="_blank">clicando aqui</a>.</p>
        </div>
    </div>
</section>

<style>
.products-container {
    overflow: hidden;    
}

.products-container .product img {
    width: 150px;
}

.products-container .product:not(:last-child) {
    margin-bottom: 60px;
}

.products-container .product .product-description a {
    text-decoration: none;
    color: #07c;
}

.products-container .product .product-description a:hover {
    border-bottom: 1px solid #07c;
}

.products-container .product .product-title {
    font-weight: 600;
    color: #444;
}

@media(min-width:768px) {
    .products-container {
        width: 700px;
        margin: 0 auto;
    }

    .products-container .product {
        position: relative;        
    }

    .products-container .product img {
        position: absolute;
        left: 0;
        padding: 30px 0;    
        top: -30px;
        display: block;
        cursor: pointer;
    }

    .products-container .product .product-title,
    .products-container .product .product-description {
        padding-left: 200px;
    }
}
</style>
